import { createTheme } from "@mantine/core";

const inputSurface = {
  border: "1px solid rgba(203, 213, 225, 0.95)",
  borderRadius: 16,
  background: "rgba(255, 255, 255, 0.86)",
  color: "#111827",
  fontSize: 15,
  fontWeight: 500,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
  transition: "border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
};

export const dutyonTheme = createTheme({
  primaryColor: "blue",
  primaryShade: { light: 6, dark: 7 },
  defaultRadius: "md",
  radius: {
    xs: "4px",
    sm: "6px",
    md: "8px",
    lg: "14px",
    xl: "18px",
  },
  defaultGradient: {
    from: "#1c7ed6",
    to: "#1564bf",
    deg: 135,
  },
  cursorType: "pointer",
  components: {
    Input: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
      styles: {
        input: {
          ...inputSurface,
          minHeight: 54,
        },
        section: {
          color: "#6b7280",
        },
      },
    },
    InputWrapper: {
      defaultProps: {
        size: "md",
      },
      styles: {
        label: {
          color: "#374151",
          fontSize: 13,
          fontWeight: 700,
          marginBottom: 8,
        },
        description: {
          color: "#6b7280",
          fontSize: 12,
          marginTop: 4,
        },
        error: {
          color: "#e03131",
          fontSize: 12,
          fontWeight: 600,
          marginTop: 7,
        },
      },
    },
    TextInput: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
    },
    PasswordInput: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
      styles: {
        innerInput: {
          fontSize: 15,
          fontWeight: 500,
        },
        visibilityToggle: {
          borderRadius: 12,
          color: "#6b7280",
        },
      },
    },
    Textarea: {
      defaultProps: {
        size: "md",
        radius: "lg",
        minRows: 4,
      },
      styles: {
        input: {
          ...inputSurface,
        },
      },
    },
    Select: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
      styles: {
        dropdown: {
          border: "1px solid rgba(203, 213, 225, 0.95)",
          borderRadius: 14,
          boxShadow: "0 18px 40px rgba(15, 23, 42, 0.12)",
        },
        option: {
          borderRadius: 10,
          fontWeight: 500,
        },
      },
    },
    NumberInput: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
    },
    DateInput: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
    },
    DatePickerInput: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
    },
    TimeInput: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
    },
    Checkbox: {
      defaultProps: {
        size: "md",
        radius: "sm",
      },
      styles: {
        input: {
          borderColor: "#cbd5e1",
        },
        label: {
          color: "#4b5563",
          lineHeight: 1.5,
        },
        error: {
          color: "#e03131",
          fontSize: 12,
          fontWeight: 600,
          marginTop: 6,
        },
      },
    },
    Switch: {
      defaultProps: {
        size: "md",
        radius: "xl",
        color: "blue",
      },
      styles: {
        label: {
          color: "#4b5563",
          lineHeight: 1.5,
        },
        track: {
          borderColor: "#cbd5e1",
        },
      },
    },
    Button: {
      defaultProps: {
        size: "md",
        radius: "lg",
      },
      styles: {
        root: {
          minHeight: 44,
          fontWeight: 700,
          transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
        },
        label: {
          minWidth: 0,
        },
      },
    },
    ActionIcon: {
      defaultProps: {
        radius: "lg",
        variant: "subtle",
      },
      styles: {
        root: {
          transition: "transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease",
        },
      },
    },
    ThemeIcon: {
      defaultProps: {
        radius: "lg",
      },
    },
    Card: {
      defaultProps: {
        radius: "md",
        withBorder: true,
        padding: "lg",
      },
      styles: {
        root: {
          borderColor: "rgba(229, 231, 235, 0.9)",
          boxShadow: "0 12px 30px rgba(15, 23, 42, 0.06)",
        },
      },
    },
    Paper: {
      defaultProps: {
        radius: "md",
        withBorder: true,
      },
      styles: {
        root: {
          borderColor: "rgba(229, 231, 235, 0.9)",
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.05)",
        },
      },
    },
    Alert: {
      defaultProps: {
        radius: "lg",
      },
      styles: {
        root: {
          borderColor: "rgba(203, 213, 225, 0.9)",
        },
        title: {
          fontWeight: 700,
        },
      },
    },
    Modal: {
      defaultProps: {
        radius: "xl",
        centered: true,
      },
      styles: {
        content: {
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.18)",
        },
        title: {
          fontWeight: 800,
        },
      },
    },
  },
});
